// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2j3xj","title":"FrontImage_title__1BLir"};